import React, { useState } from 'react'
import PropTypes from 'prop-types'

import {
  BLUE,
  BLUE_25,
  Button,
  FileUpload,
  IconInline,
  Paragraph,
  RED,
  TextArea
} from '@omnilert/components'

import i18n from 'i18n-js'
import { USER_ERROR_MAX_UPLOADS } from '@assets/i18n/strings'

import useStyles from './tip-input-container.styles'
import { useDispatch, useSelector } from 'react-redux'
import { selectTip } from '@selectors'

import {
  PLACEHOLDER_TIP
} from '../../assets/i18n/strings'

import { FILE_SELECT } from '@redux/actions/types'

const TipInputContainer = ({ handleInputChange, isSubmittingTip }) => {
  const tipData = useSelector(selectTip)

  const { fileUploads, message } = tipData
  const dispatch = useDispatch()
  const [maxUploadError, setShowMaxUploadError] = useState(false)
  
  const imagesText = fileUploads?.length ? `${fileUploads.length} / 3` : '0 / 3'


  const onSelect = (file, error) => {
    if (error) {
      setShowMaxUploadError(true)
    } else {
      setShowMaxUploadError(false)
      dispatch({
        type: FILE_SELECT,
        payload: file
      })
    }
  }

  const submitButtonDisabled = !message || (message && message === '')
  
  const uploadDisabled = fileUploads.length >= 3
  
  const classes = useStyles({ submitButtonDisabled, uploadDisabled })
  
  return (
    <section className={classes.tipInputContainer}>
      <div data-testid='tip-message-input'>
        <TextArea
          ariaLabel='tip input'
          name='message'
          onChange={handleInputChange}
          placeholder={i18n.t(PLACEHOLDER_TIP)}
          textAreaClassName={classes.textArea}
          type='text'
          value={message}
        />
      </div>

      <div
        className={classes.textAreaButtonContainer}
      >
        <FileUpload
          accept='image/*, video/*'
          disabled={uploadDisabled}
          onSelect={onSelect}
        >
          <div className={classes.uploadContainer}>
            <Button
              ariaLabel='upload photo button'
              className={classes.cameraButton}
              disabled={uploadDisabled}
              icon={<IconInline
                className={classes.cameraIcon}
                name='photo'
                size={20}
              />}
              type='button'
            />
            <Paragraph
              color={uploadDisabled ? BLUE_25 : BLUE}
              size='xs'
            >{imagesText}
            </Paragraph>
          </div>
        </FileUpload>
        <div data-testid='tip-submit-button'>
          <Button
            ariaLabel='submit tip button'
            className={classes.submitButton}
            disabled={submitButtonDisabled}
            icon={<IconInline
              name='send'
              size={22}
            />}
            isLoading={isSubmittingTip}
            type='submit'
            variant='solid'
          />
        </div>
      </div>
      {maxUploadError && (
        <Paragraph
          className={classes.errorMessage}
          color={RED}
          size='sm'
        >
          {i18n.t(USER_ERROR_MAX_UPLOADS)}
        </Paragraph>
      )}
    </section>
  )
}

TipInputContainer.defaultProps = {
  isSubmittingTip: false
}

TipInputContainer.propTypes = {
  handleInputChange: PropTypes.func,
  isSubmittingTip: PropTypes.bool
}
export default TipInputContainer
